import { getCookie } from 'shared/lib/getCookie';

export const API_URL = `${getCookie(`CP_SAS_CLIENTAPI_URL`) || `https://clientapi.cloupard.uz`}/api/v1/`;
